import axios from '../utils/axios';

export default function fetchCourseIntegrations(adminId,params) {
    return (
        axios.get('/admin/' + adminId +'/courses/course-mapping/integrations',  {params} )
    )
}